import React from 'react'
import {
    Box,
    Link,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from '@mui/material'
import { getPaymentTypeBackground } from '../../common/helper'
import { getBackgroundColour } from './Constants'
import { useSetAtom } from 'jotai'
import { alertAtom, globalLoaderAtom } from '../../common/jotaiState/globalStateAtoms'
import { GetRequest } from '../../common/api'
import { urls } from '../../common/constants'

const DashboardCard = ({
    title = '',
    columnDefs = [],
    rowData = {},
    onTitleClick,
    width = '100%',
    reportData,
    cellValues,
    criteriaHeaders,
    criteriaData,
    reportColDefs
}) => {
    const setAlert = useSetAtom(alertAtom)
    const setLoader = useSetAtom(globalLoaderAtom)
    const getAlignment = (column) => {
        const align = column?.headerSx?.textAlign

        if (align === 'right') return 'right'
        if (align === 'left') return 'left'

        return 'center'
    }
    const getPaymentTypeValue = (tblName, cellNo) => {
        switch (tblName) {
            case 'Booked Packages':
            case 'SC Trans Received':
            case 'Dispatched Packages':
            case 'Received Packages':
            case 'Expected Packages':
            case 'Branch Transfer':
                if (cellNo === 0) return 1;
                else if (cellNo === 1) return 4
                else if (cellNo === 2) return 5
                else if (cellNo === 3) return 3
           
            case 'Allocation Status':
            case 'Out Delivery Status':
            case 'Returned Status':
            case 'Normal Delivery Status':
                return 0;

            case 'COD Collection': return 4;
            case 'Normal Delivery Collection': return -1;
        }
    }
    const getMOdeValue = (tblName, cellNo) => {
        switch (tblName) {
            case 'Booked Packages':
                return 'B';
            case 'Branch Transfer':
                return 'BT';
            case 'SC Trans Received':
                return 'SBT';
            case 'Dispatched Packages':
                return 'D';
            case 'Received Packages':
                return 'R';
            case 'Expected Packages':
                return 'EXP';

            case 'Allocation Status':
                if (cellNo === 0) return 'R';
                else if (cellNo === 1) return 'AL';
                else if (cellNo === 2) return 'TBA';
            case 'Out Delivery Status':
                if (cellNo === 0) return 'AL';
                else if (cellNo === 1) return 'ALDEL';
                else if (cellNo === 2) return 'ALTBD';
            case 'Returned Status':
                if (cellNo === 0) return 'ALTBD';
                else if (cellNo === 1) return 'TR';
                else if (cellNo === 2) return 'ALTBD';
            case 'Normal Delivery Status':
                if (cellNo === 0) return 'R';
                else if (cellNo === 1) return 'DEL';
                else if (cellNo === 2) return 'TBDEL';

            case 'COD Collection':
                if (cellNo === 0) return 'DEL';
                else if (cellNo === 1) return 'TBDEL';
            case 'Normal Delivery Collection':
                if (cellNo === 0) return 'DEL';
                else if (cellNo === 1) return 'TBDEL';
        }
    }
    const handleCellClick = (cellNo) => {

        try {
            let body = {
                ...cellValues,
                strMode: getMOdeValue(title, cellNo),
                paymenttypeid: getPaymentTypeValue(title, cellNo)
            }

            setLoader(true)

            GetRequest(urls.getDashboardPymtTypeWiseData, body)
                .then((res) => {
                    setLoader(false)

                    if (res.status !== 'Success') {
                        setAlert({ show: true, msg: res?.ErrMessage || 'Something went wrong', nextId: '' })
                        return
                    }

                    const reportData = res?.Data?.Table?.map((val, i) => ({
                        ...val, SN: i + 1, dataType: 'entry'
                    }))

                    if (!reportData?.length) {
                        setAlert({ show: true, msg: 'No Data Found', nextId: '' })
                        return
                    }
                    const totalUnits = reportData.reduce(
                        (sum, row) => sum + (Number(row.UnitsCount) || 0),
                        0
                    )                    
                    const totalAmount = Number(
                        reportData.reduce((sum, row) => sum + (Number(row.NetAmount) || 0), 0).toFixed(2)
                    )
                    reportData.push({                        
                        SN: 'TOTAL',
                        UnitsCount: totalUnits,
                        NetAmount: totalAmount,
                        dataType: 'total',
                        colSpan: { SN: 10, },
                        align: { SN: 'left' },
                    })
                    
                    let mainHeader = reportColDefs?.map((item) => ({
                        ...item,
                        field: item.dataKey,
                        align: item.headerSx.textAlign,
                        exportHead: item.header,
                        weight: item?.weight ?? 80
                    }))
                   let reportPayload = {
                        reportName: title,
                        criteriaHeaders: criteriaHeaders,
                        criteriaData: [criteriaData],
                        tableData: reportData,
                        mainHeader: mainHeader,
                        showColumnBorders: true,
                    }
                    const rid = Date.now().toString()

                    if (!window.generatedReports) {
                        window.generatedReports = {}
                    }

                    window.generatedReports[rid] = reportPayload

                    window.open(`/view-report?rid=${rid}`, "_blank")
                })

                .catch((err) => {
                    setLoader(false)
                    setAlert({ show: true, msg: err.message, nextId: '' })
                })
        } catch (err) {
            setLoader(false)
            setAlert({ show: true, msg: err.message, nextId: '' })
        }
    }
    return (
        <Box sx={{ width }}>
            {/* Title Outside Table */}
            {/* <Box
                sx={{
                    mb: 0.5,
                    pl: 0,
                }}
            >
                <Link
                    component="button"
                    underline="hover"
                    onClick={onTitleClick}
                    sx={{
                        fontSize: '13px',
                        fontWeight: 600,
                        color: '#000000',
                        textAlign: 'left',
                        textDecorationThickness: '1px',
                    }}
                >
                    {title}
                </Link>
            </Box> */}
            <Box
                sx={{
                    mb: 0.5,
                    pl: 0,
                }}
            >
                <Typography
                    sx={{
                        fontSize: '13px',
                        fontWeight: 600,
                        color: '#000000',
                        textAlign: 'left',
                    }}
                >
                    {title}
                </Typography>
            </Box>
            <TableContainer
                sx={{
                    border: '1px solid #6d6d6d',
                    borderRadius: '6px',
                    overflow: 'hidden',
                    backgroundColor: '#fff',
                }}
            >
                <Table
                    size="small"
                    sx={{
                        tableLayout: 'fixed',
                        borderCollapse: 'separate',
                        borderSpacing: 0,

                        '& .MuiTableCell-root': {
                            padding: '4px 6px',
                            borderRight: '1px solid #6d6d6d',
                            borderBottom: '1px solid #6d6d6d',
                        },

                        '& .MuiTableCell-root:last-child': {
                            borderRight: 'none',
                        },

                        '& tbody tr:last-child td': {
                            borderBottom: 'none',
                        },
                    }}
                >
                    <TableHead>
                        <TableRow>
                            {columnDefs.map((column, index) => (
                                <TableCell
                                    key={column.dataKey}
                                    align={getAlignment(column)}
                                    sx={{
                                        backgroundColor:
                                            getPaymentTypeBackground(column?.dataKey) ||
                                            getBackgroundColour(column?.header),

                                        fontWeight: 600,
                                        whiteSpace: 'pre-line',
                                        fontSize: '13px',
                                        color: '#444444',

                                        ...(index === 0 && {
                                            borderTopLeftRadius: '6px',
                                        }),

                                        ...(index === columnDefs.length - 1 && {
                                            borderTopRightRadius: '6px',
                                        }),

                                        ...column.headerSx,
                                    }}
                                    onClick={() => {
                                        // handleCellClick()
                                    }}
                                >
                                    {column.header}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            {columnDefs.map((column, index) => (
                                <TableCell
                                    key={column.dataKey}
                                    align={getAlignment(column)}
                                    sx={{
                                        backgroundColor: '#f7f9ff',
                                        fontWeight: 500,
                                        fontSize: '14px',
                                        cursor: 'pointer'
                                    }}
                                    onClick={() => handleCellClick(index)}
                                >
                                    <Typography
                                        sx={{
                                            fontWeight: 500,
                                            fontSize: '14px',
                                        }}
                                    >
                                        {rowData?.[column.dataKey] ?? 0}
                                    </Typography>
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    )
}

export default DashboardCard